import React, { useState, useRef } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { WebcamVideoTexture } from '@react-three/drei'
import { AsciiRenderer } from './AsciiRenderer'


function WebcamMesh({ texture }) {
    const { viewport } = useThree()
    const [videoAspect, setVideoAspect] = useState(null)

    useFrame(() => {
      if (!videoAspect) {
        const video = texture.image
        if (video && video.videoWidth > 0 && video.videoHeight > 0) {
          setVideoAspect(video.videoWidth / video.videoHeight)
        }
      }
    })

    if (!videoAspect) return null

    const canvasAspect = viewport.width / viewport.height
    let w, h
    if (videoAspect > canvasAspect) {
      w = viewport.width
      h = viewport.width / videoAspect
    } else {
      h = viewport.height
      w = viewport.height * videoAspect
    }

    return (
      <mesh>
        <planeGeometry args={[w, h]} />
        <meshBasicMaterial map={texture} toneMapped={false} />
      </mesh>
    )
}


export default function WebcamComponentR3F(props) {
    return (
      <>
          <AsciiRenderer 
                characters={'.:-+*=%@#'}
                resolution={0.1}
          />
        <WebcamVideoTexture>
            {(texture) => <WebcamMesh texture={texture} />}
        </WebcamVideoTexture>
      </>
    )
  }
  